// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // baseUrl : 'http://localhost:5001/attimo-spepm-dev/us-central1/api',
  baseUrl : 'https://us-central1-attimo-spepm-dev.cloudfunctions.net/api',
};

export const firebaseEnvironment = {
  config: {
    apiKey: 'AIzaSyARZSVqUFi3Q6a_aFRasNeKZsJPj3ZNcgg',
    authDomain: 'attimo-spepm-dev.firebaseapp.com',
    projectId: 'attimo-spepm-dev',
    storageBucket: 'attimo-spepm-dev.appspot.com',
    messagingSenderId: '450765036054',
    appId: '1:450765036054:web:ac9a5b460a2c388c2ff337',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
